export const CHANGED_INDEX = "CHANGED_INDEX";
export const TOGGLED_FULLSCREEN = "TOGGLED_FULLSCREEN"